/* eslint-disable */
/* this file is generated by generateIcons script */

// @ts-ignore
import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AccountTypeCustomerIcon extends BaseIcon {
    getChildren = () => [ <g transform="translate(0 -3)">
        <g transform="translate(0 3)">
            <circle cx="15.777" cy="15.777" r="15.777" fill="#f2f2f2"/>
            <g transform="translate(8.834 8.139)">
                <path d="M6.92,15.277a1.646,1.646,0,0,1-.645-.132l-.646-.273A9.535,9.535,0,0,1,1.678,11.7,8.277,8.277,0,0,1,0,6.826V2.448A1.325,1.325,0,0,1,.723,1.266,16.413,16.413,0,0,1,6.918,0a16.691,16.691,0,0,1,6.246,1.266,1.335,1.335,0,0,1,.721,1.215V6.826a8.188,8.188,0,0,1-1.7,4.865A9.883,9.883,0,0,1,8.2,14.872l-.637.273A1.646,1.646,0,0,1,6.92,15.277Zm.035-8.032h0a3.048,3.048,0,0,0-3.047,2.97.088.088,0,0,0,0,.079.114.114,0,0,0,.084.034H9.836a.155.155,0,0,0,.107-.045.138.138,0,0,0,.041-.108,3.059,3.059,0,0,0-3.021-2.93Zm0-4.08a1.694,1.694,0,0,0-1.693,1.7,1.7,1.7,0,1,0,1.693-1.7Z" fill="#2e3f58"/>
            </g>
        </g>
    </g> ]
    getViewBox = () => '0 0 31.555 31.555'
}
